import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ConfirmationModal = ({ show, onConfirm, onCancel, title = "Unsaved changes", message = "Your changes haven't been saved.\nAre you sure you want to leave the page?" }) => {
    return (
        <Modal
            show={show}
            onHide={onCancel}
            centered
            size="md"
            style={{ zIndex: 9999 }}
            backdrop="static"
            dialogClassName="confirmation-modal"
        >
            <Modal.Header
                closeButton
                style={{
                    borderBottom: '1px solid #e0e0e0',
                    paddingBottom: '1rem',
                    paddingTop: '1rem',
                    paddingLeft: '1.5rem',
                    paddingRight: '1.5rem'
                }}
            >
                <Modal.Title style={{ fontSize: '1rem', fontWeight: '600' }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ paddingTop: '1.5rem', paddingBottom: '1.5rem', paddingLeft: '1.5rem', paddingRight: '1.5rem', fontSize: '0.95rem', color: '#555', lineHeight: '1.6' }}>
                <p style={{ marginBottom: '0.3rem', marginTop: '0' }}>Your changes haven't been saved.</p>
                <p style={{ marginBottom: '0', marginTop: '0.3rem' }}>Are you sure you want to leave the page?</p>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e0e0e0', paddingTop: '1rem', paddingBottom: '1rem', paddingLeft: '1.5rem', paddingRight: '1.5rem', gap: '0.75rem' }}>
                <Button
                    variant="outline-secondary"
                    onClick={onConfirm}
                    style={{ color: '#333', borderColor: '#999', fontSize: '0.85rem', padding: '0.4rem 1rem' }}
                >
                    Leave anyway
                </Button>
                <Button
                    variant="primary"
                    onClick={onCancel}
                    style={{ backgroundColor: '#6c3fbf', borderColor: '#6c3fbf', fontSize: '0.85rem', padding: '0.4rem 1rem' }}
                >
                    Stay on page
                </Button>
            </Modal.Footer>
            <style>{`
                .confirmation-modal .modal-content {
                    border: 1px solid #d0d0d0;
                    border-radius: 0.375rem;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }
                .confirmation-modal .modal-footer {
                    display: flex !important;
                    justify-content: flex-end !important;
                }
            `}</style>
        </Modal>
    );
};

export default ConfirmationModal;